'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.ScreenWidth = void 0;
(function (ScreenWidth) {
    ScreenWidth["WIDESCREEN"] = "1728px";
    ScreenWidth["DESKTOP"] = "1440px";
    ScreenWidth["LAPTOP"] = "1024px";
    ScreenWidth["TABLET_PORTRAIT"] = "768px";
    ScreenWidth["MOBILE_LANDSCAPE"] = "576px";
    ScreenWidth["MOBILE_PORTRAIT"] = "414px";
})(exports.ScreenWidth || (exports.ScreenWidth = {}));
